var map = {
	"./symbol_0.png": "9d35",
	"./symbol_1.png": "6125",
	"./symbol_2.png": "cda6",
	"./symbol_3.png": "b56c",
	"./symbol_4.png": "455c",
	"./symbol_5.png": "7eab",
	"./symbol_6.png": "3a40",
	"./symbol_7.png": "135f",
	"./symbol_8.png": "86b7",
	"./symbol_9.png": "f29e"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "eee5";